import { Handle } from 'reactflow';
import { IconButton } from '@mui/material';
import Iconify from 'src/components/iconify';

export default function RoleNode({ data, isConnectable }) {
  const safeData = data || {};
  const roleName = safeData.roleName ?? 'New Role';
  const color = safeData.color ?? '#A9A9A9';
  const nodeId = safeData.id;
  const onDelete = safeData.onDelete;
  const onEdit = safeData.onEdit; 
  const backgroundColor = `${color}20`;
  const borderColor = color;

  const handleDelete = () => {
    if (onDelete && nodeId) {
      onDelete(nodeId);
    }
  };
  
  const handleEdit = () => {
    if (onEdit) {
      onEdit({ 
        id: nodeId, 
        name: roleName 
      });
    }
  };
  
  return (
    <div
      style={{
        backgroundColor: backgroundColor,
        borderRadius: '12px',
        padding: '20px',
        width: '240px',
        boxShadow: `0 6px 12px rgba(0,0,0,0.12)`,
        position: 'relative',
        fontFamily: 'sans-serif',
        color: '#333',
        fontWeight: 'bold',
      }}
    >
      <Handle
        type="target"
        position="top"
        style={{ background: borderColor, width: 25, height: 16, borderRadius: '4px' }}
        isConnectable={isConnectable}
      />
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          fontWeight: 'bold',
          fontSize: '16px',
        }}
      >
        <span>{roleName}</span>
      </div>
      <hr style={{ border: '1.5px solid black', margin: '10px 0' }} />
      <div style={{ display: 'flex', justifyContent: 'center', gap: '14px' }}>
        <IconButton  
          onClick={handleEdit}
          size="small" 
          style={{ backgroundColor: 'white', borderRadius: '50%' }}
        >
          <Iconify icon="material-symbols:edit" />
        </IconButton>
        <IconButton
          size="small"
          style={{ backgroundColor: 'white', borderRadius: '50%' }}
          onClick={handleDelete}
        >
          <Iconify icon="material-symbols:close-rounded" />
        </IconButton>
      </div>
      <hr style={{ border: '1.5px solid black', margin: '10px 0' }} />
      <Handle
        type="source"
        position="bottom"
        style={{ background: borderColor, width: 25, height: 16, borderRadius: '4px' }}
        isConnectable={isConnectable}
      />
    </div>
  )
}